import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";

export default function CityInsight({ item }) {
    return (
        <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 items-start">
            <figure className="w-full sm:w-[252px] sm:h-[142px] flex-shrink-0">
                <Image
                    src={item.cityImageUrl || "/images/dummy/hotel-city.jpg"}
                    width={252}
                    height={142}
                    alt={"hotel-city-insight"}
                    className="w-full sm:w-[252px] sm:h-[142px] object-cover rounded-lg"
                    priority
                />
            </figure>

            <div className="col-span-4 lg:col-span-3 grid gap-4 sm:gap-6 grid-cols-2 items-start flex-1 min-w-0">
                {item.datas.map((data) => (
                    <Link
                        key={data.id}
                        href={data.link}
                        className="block w-full min-w-0 overflow-hidden truncate text-lg text-foreground font-medium"
                        title={data.text}
                    >
                        {data.text}
                    </Link>
                ))}
            </div>
        </div>




    )

}
